import { Observable } from 'rxjs';
import {
  OrderModel,
  EmployeeDTO,
  RequestTemplateDTO,
  T22EntityItemDTO,
  RequestActDTO,
  StatusDTO,
  OrdersForNotification,
} from 'src/app/store/order/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractOrderApiService {
  public abstract getOrders(userId: number, fromDate: Date, toDate: Date): Observable<InteractorResponse<OrderModel[]>>;
  public abstract getOrderById(id: number, userId: number): Observable<InteractorResponse<OrderModel>>;
  public abstract getForWhomEmployees(
    userId: number,
    categoryId: number,
    serviceId: number,
    mask: string
  ): Observable<InteractorResponse<EmployeeDTO[]>>;
  public abstract getInitiatorEmployees(
    userId: number,
    categoryId: number,
    serviceId: number,
    mask: string
  ): Observable<InteractorResponse<EmployeeDTO[]>>;
  public abstract getCoordinatorEmployees(
    userId: number,
    categoryId: number,
    serviceId: number
  ): Observable<InteractorResponse<EmployeeDTO[]>>;
  public abstract createOrder(order: OrderModel, files: any[]): Observable<InteractorResponse<OrderModel>>;
  public abstract saveOrder(
    order: OrderModel,
    isChangedOrder: boolean,
    userId: number,
    files: any[]
  ): Observable<InteractorResponse<OrderModel>>;
  public abstract getTemplate(categoryId: number, serviceId: number): Observable<InteractorResponse<RequestTemplateDTO>>;
  public abstract saveStatus(
    orderId: number,
    mark: number,
    userId: number,
    comment: string,
    files: any[],
    newStatusId: number
  ): Observable<InteractorResponse<OrderModel>>;
  public abstract getDictionary(dictionary: number): Observable<InteractorResponse<T22EntityItemDTO[]>>;
  public abstract getActs(id: number): Observable<InteractorResponse<RequestActDTO[]>>;
  public abstract getAllowedStatuses(id: number, userId: number): Observable<InteractorResponse<StatusDTO[]>>;
  public abstract createAct(id: number, userId: number, value: string): Observable<InteractorResponse<RequestActDTO>>;
  public abstract canSaveStatus(orderId: number, userId: number, newStatusId: number): Observable<InteractorResponse<boolean>>;
  public abstract getOrdersForNotification(userId: number): Observable<InteractorResponse<OrdersForNotification[]>>;
}
